import {
  ACTIVE,
  DEACTIVATED,
  DECLINED,
  INVITE_ACCEPTED,
  INVITE_ACCEPTED_OFFLINE,
  INVITE_DECLINED,
  INVITE_PENDING,
  PENDING,
} from '@rsos/constants/peerAgenciesStatuses';

/**
 * Given a peer agency link status, return the display name
 *
 * @param {string} status - agency link status
 * @returns string
 */
export const agencyStatusMap = status => {
  const agency = {
    [ACTIVE]: INVITE_ACCEPTED,
    [DEACTIVATED]: INVITE_ACCEPTED_OFFLINE,
    [PENDING]: INVITE_PENDING,
    [DECLINED]: INVITE_DECLINED,
  };
  return agency[status] || null;
};
